import { render, staticRenderFns } from "./brokerInsuredApprovalDetail.vue?vue&type=template&id=697f4ee5&scoped=true"
import script from "./brokerInsuredApprovalDetail.vue?vue&type=script&lang=js"
export * from "./brokerInsuredApprovalDetail.vue?vue&type=script&lang=js"
import style0 from "./brokerInsuredApprovalDetail.vue?vue&type=style&index=0&id=697f4ee5&prod&scoped=true&lang=css"
import style1 from "./brokerInsuredApprovalDetail.vue?vue&type=style&index=1&id=697f4ee5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697f4ee5",
  null
  
)

export default component.exports